export const useHMSPeerId = (peerId: string) => ({
  externalPeerId: peerId,
});
